import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import CreateAccountCodeModal from "../components/CreateAccountCodeModal";
import EditAccountCodeModal from "../components/EditAccountCodeModal";
import api from '../config/api';


import "../styles/account_codes.css";


export default function AccountCodes() {
    const [codes, setCodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCode, setSelectedCode] = useState(null);

    const itemsPerPage = 10;
    

    const filteredCodes = codes.filter((item) =>
        item.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );

    const paginatedCodes = filteredCodes.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const totalPages = Math.ceil(filteredCodes.length / itemsPerPage);


    const fetchCodes = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(api("/account_codes/"), {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });

            const data = await response.json();

            // Cek apakah data adalah array
            if (Array.isArray(data)) {
            // Sort berdasarkan kode akun (ascending) dengan null-handler
            data.sort((a, b) => {
                const codeA = a?.code?.toString() || "";
                const codeB = b?.code?.toString() || "";
                return codeA.localeCompare(codeB);
            });

            setCodes(data);
            } else {
            console.warn("Account codes response is not an array:", data);
            setCodes([]); // fallback kosong
            }
        } catch (err) {
            console.error("Error fetching account codes:", err);
            setCodes([]); // fallback kosong
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchCodes();
    }, []);

    const handleDelete = async (id) => {
        const confirm = window.confirm("Are you sure you want to delete this account code?");
        if (!confirm) return;
    
        try {
        const token = localStorage.getItem("token");
        const res = await fetch(api(`/account_codes/${id}`), {
            method: "DELETE",
            headers: {
            Authorization: `Bearer ${token}`,
            },
        });
    
        if (res.ok) {
            fetchCodes(); // refresh data
        } else {
            alert("Failed to delete");
        }
        } catch (err) {
        console.error(err);
        }
    };
  
    return (
        <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
            <Sidebar />
            <div className="layout-page">
            <Navbar />
            <div className="content-wrapper">
                <div className="container-xxl flex-grow-1 container-p-y">
                <h2 className="mb-4">Account Codes</h2>

                {loading ? (
                    <div>Loading...</div>
                ) : (
                <div className="card">
                    <div className="table-responsive">
                    <div className="mb-3 px-3" style={{ maxWidth: "300px" }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by code or name"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                        <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Parent</th>
                            <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {paginatedCodes.map((item) => (
                            <tr key={item.id}>
                                <td>{item.code}</td>
                                <td>{item.name}</td>
                                <td>{item.description || "-"}</td>
                                <td>
                                {
                                    item.parent_id
                                    ? (codes.find(code => code.id === item.parent_id)?.code || "-")
                                    : "-"
                                }
                                </td>
                                <td>
                                <div className="d-flex gap-2">
                                    <button
                                    className="btn btn-sm btn-icon text-primary"
                                    title="Edit"
                                    onClick={() => {
                                        setSelectedCode(item);
                                        setShowEditModal(true);
                                    }}
                                    >
                                        <i className="bx bx-edit"></i>
                                    </button>

                                    <button
                                    className="btn btn-sm btn-icon text-danger"
                                    title="Delete"
                                    onClick={() => handleDelete(item.id)}
                                    >
                                        <i className="bx bx-trash"></i>
                                    </button>
                                </div>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                        <div className="d-flex justify-content-between align-items-center mt-3 px-3">
                            <small>Page {currentPage} of {totalPages}</small>
                            <div>
                                <button
                                className="btn btn-sm btn-outline-secondary me-2"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                Previous
                                </button>
                                <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                Next
                                </button>
                            </div>
                        </div>

                        <button
                            className="fab-ac"
                            onClick={() => setShowCreateModal(true)}
                            >
                            <span className="icon">+</span>
                            <span className="label">Create Account Code</span>
                        </button>
                    </div>
                </div>
                )}
                </div>
            </div>
            </div>
        </div>
        <CreateAccountCodeModal
            show={showCreateModal}
            onClose={() => setShowCreateModal(false)}
            onSuccess={fetchCodes}
        />
        <EditAccountCodeModal
            show={showEditModal}
            onClose={() => setShowEditModal(false)}
            onSuccess={fetchCodes}
            selectedCode={selectedCode}
        />

        </div>
        
    );
}
